module.exports = __webpack_public_path__ + "img/3.6f6a3b99.svg";